(function() {

  setTimeout(() => {
    const style = document.createElement('style');
    const hostAvg = document.querySelector('#app-embed-container-260142');
    style.innerHTML = `
    section._grid_stahb_148._left_stahb_195 {
      grid-template-areas:
          'image'
          'content';
      grid-template-columns: 1fr;
      grid-template-rows: 45px min-content;
      max-width: 483px;
      border-radius: 1px;
      padding: 58px 55px 92px;
      row-gap: 60px;
    }
  
    ._gridItem_stahb_172:nth-child(1) {
        width: 246px;
        height: 45px;
        margin: 0 auto;
        
    }
    ._gridItem_stahb_172:nth-child(2) {
      padding: 0;
    }
  
    section[aria-label="Success"] ._gridItem_stahb_172:nth-child(2),
    section[aria-label="Success"] ._textBody_2aowh_10 {
      padding: 35px 30px;
    }
    section[aria-label="Success"] ._textBody_2aowh_10 {
      display: block;
    }
  
    section section._formHeader_1ll8d_19 {
      margin-bottom: 35px;
    }
  
    section form._formFieldset_1ll8d_67 {
      row-gap: 15px;
    }
  
    section ._grid_stahb_148._left_stahb_195 ._gridItem_stahb_172:nth-child(1) {
      border-radius: 1px;
    }
    section h2._textHeading_2aowh_35 {
      font-family: Inria Serif;
      font-size: 55px;
      font-weight: 400;
      line-height: 35px;
      text-align: left;
      text-underline-position: from-font;
      text-decoration-skip-ink: none;
      text-align: center;
    }
  
    section input._formInputField_237zm_7 {
      border-radius: 1px;
      border: 1px solid #000000;
      font-family: Inria Serif;
    }
    section button._formSubmitButton_1ll8d_81 {
      border-radius: 1px;
      font-family: Inria Serif;
      font-size: 15px;
      font-weight: 400;
      line-height: 20px;
      text-align: center;
      text-underline-position: from-font;
      text-decoration-skip-ink: none;
    }
  
    ._textBody_2aowh_10,
    ._formDisclaimer_1ll8d_37 {
      display: none;
      
    }
    section label#label-email._formInputFieldLabel_1ydxd_37 {
        left: 35%;
        color: #000000;
        font-family:  Inria Serif;
        font-size: 15px;
    }

    @media screen and (max-width: 600px) {
      section._grid_stahb_148._left_stahb_195 {
           padding: 58px 20px 71px;
           width: 80vw;
           min-width: 80%;
      }
      section h2._textHeading_2aowh_35 {
        font-size: 45px;
      }
    }
    `
    console.log(hostAvg);
    console.log(hostAvg.shadowRoot)
    if (hostAvg) {
       hostAvg.shadowRoot.appendChild(style)
       hostAvg.shadowRoot.querySelector('label#label-email._formInputFieldLabel_1ydxd_37').textContent = 'Email Address';
      // waitForElm(hostAvg.shadowRoot).then((elm) => {
      //    hostAvg.shadowRoot.appendChild(style)
      // });
    }
  
  }, 1500)

function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                observer.disconnect();
                resolve(document.querySelector(selector));
            }
        });

        // If you get "parameter 1 is not of type 'Node'" error, see https://stackoverflow.com/a/77855838/492336
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}
})()